import { render, staticRenderFns } from "./layouts.vue?vue&type=template&id=c287deb0&scoped=true&"
import script from "./layouts.vue?vue&type=script&lang=js&"
export * from "./layouts.vue?vue&type=script&lang=js&"
import style0 from "./layouts.vue?vue&type=style&index=0&id=c287deb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c287deb0",
  null
  
)

export default component.exports